import { render, staticRenderFns } from "./safetyGearGiveDetail.vue?vue&type=template&id=14fcffac"
import script from "./safetyGearGiveDetail.vue?vue&type=script&lang=js"
export * from "./safetyGearGiveDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14fcffac')) {
      api.createRecord('14fcffac', component.options)
    } else {
      api.reload('14fcffac', component.options)
    }
    module.hot.accept("./safetyGearGiveDetail.vue?vue&type=template&id=14fcffac", function () {
      api.rerender('14fcffac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/sas/safetyGearGiveDetail.vue"
export default component.exports